import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import BulletOne from "@material-ui/icons/LooksOne";
import BulletTwo from "@material-ui/icons/LooksTwo";
import BulletThree from "@material-ui/icons/Looks3";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>Management is based on three pillars</h2>
          <h5 className={classes.description}>

          </h5>

          <h5 className={classes.description}>Our client´s interest first is the core of our asset management philosophy.
We also custom tailor your investment strategies to clients’ specific needs.
</h5>
        </GridItem>
      </GridContainer>
      <GridContainer>

        <GridItem md={4} sm={4}>
          <InfoArea
            title="PLANNING"
            description={
              <span>
                <p>
                  Support in the design and materialization of investment structures and the design of business plans.
                  Asset Lifecycle Management (ALM) is the process of optimizing the profit generated by your assets throughout their lifecycle.
                  Comprehensive asset portfolio management, rigorous project execution, and effective and efficient asset management practices help deliver desired outcomes.
                  Our suite of service offerings addresses all the stages of an asset’s lifecycle regardless of their scope, scale or industry.
                  Drawing upon years of experience and a multitude of skill sets locally and from around the Spain, we ensure that your business needs are supported by helping you achieve optimal return on your asset base.

                </p>

              </span>
            }
            icon={BulletOne}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={4} sm={4}>
          <InfoArea
            title="MANAGEMENT"
            description={
              <span>
                <p>
                  Implementation of business plans, commercial exploitation and corporate management (accounting and tax).
                  The Asset Management area focuses its attention both on the optimization of daily operations and the maximization of revenues in order to optimize the value of real estate.
                  The degree of dialogue reaches three levels: Asset & Corporation, Financial Institutions and Investors.
                </p>

              </span>
            }
            icon={BulletTwo}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={4} sm={4}>
          <InfoArea
            title="DISINVESTMENT"
            description={
              <span>
                <p>
                  Data room preparation, support in the negotiation of sale and execution of post-transaction condition.
                  Seller/Buyer due diligence to identify risks, with the involvement of all specialised areas.
                    <ol>
                      <li>Design of an efficient legal and tax structure, identifying the most suitable investment vehicle.</li>
                      <li>Identification of the most competitive funding sources on the traditional and alternative markets.</li>
                      <li>Negotiation, design, and formalisation of the investment agreement.</li>
                      <li>Exiting</li>
                      <li>Dispose of the property.</li>
                      <li>Analysis to determine the ultimate timing and design of the exit strategy.</li>
                    </ol>
                  With the utmost confidentiality, we contact national and international potential investors whose profiles we’re fitting with.

                </p>
                
              </span>
            }
            icon={BulletThree}
            iconColor="rose"
          />
        </GridItem>



      </GridContainer>
    </div>
  );
}

export default withStyles(servicesStyle)(SectionServices);
